// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminLeadListItemResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AdminLeadListItemApiResponse = {
	id: number;
	type: string;
	email: string;
	createdAt: string;
	name: string | null;
	company: string | null;
	phone: string | null;
	industry: string | null;
	rawPayload: Record<string, string> | null;
};

export type AdminLeadListItem = {
	id: number;
	type: string;
	email: string;
	createdAt: DateTime;
	name: string | null;
	company: string | null;
	phone: string | null;
	industry: string | null;
	rawPayload: Record<string, string> | null;
};

export function hydrateAdminLeadListItem(data: AdminLeadListItemApiResponse): AdminLeadListItem {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		rawPayload: Array.isArray(data.rawPayload) ? {} : data.rawPayload,
	};
}